import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Grid,
  Typography,
  Button,
  Box,
  styled,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import Header from "components/common/dialog/Header";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { otpVerify } from "redux/slice/session/auth.slice";
import { assetsObj } from "services/images";
import Footer from "components/common/dialog/Footer";
import { toast } from "react-toastify";
import { registerResend } from "redux/slice/session/auth.slice";
import { pathApp } from "services/utiles";
// import { register } from "redux/slice/session/auth.slice";

const WhiteBorderTextField = styled("input")({
  width: "100%",
  padding: "12px 14px",
  backgroundColor: "transparent",
  border: "1px solid white",
  borderRadius: "6px",
  color: "white",
  "&:focus": {
    borderColor: "#ffffff",
  },
  "&::placeholder": {
    color: "white",
  },
  "&:focus-visible ": {
    outline: "1px solid white",
  },
});
const Verification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendMin, setResendMin] = useState(2);
  const [resendSec, setResendSec] = useState(0);
  const [ressendOtp, setResendOtp] = useState(false);

  useEffect(() => {
    if (ressendOtp) {
      var countDownTarget = new Date().getTime() + 2 * 60 * 1000;

      function showClock(target) {
        const distance = target - new Date().getTime();
        const mins =
          distance < 0
            ? 0
            : Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const secs =
          distance < 0 ? 0 : Math.floor((distance % (1000 * 60)) / 1000);

        setResendMin(mins);
        setResendSec(secs);
      }

      showClock(countDownTarget);

      var x = setInterval(function () {
        showClock(countDownTarget);
        if (countDownTarget - new Date().getTime() < 0) {
          clearInterval(x);
          setResendOtp(false);
        }
      }, 1000);

      console.log(x);
    }
  }, [ressendOtp]);

  const handleAgreementChange = () => {
    setAgreed(!agreed);
  };
  const handleResendCode = () => {
    let getUserDetail = localStorage.getItem("data");

    dispatch(registerResend(JSON.parse(getUserDetail)))
      .unwrap()
      .then((res) => {
        console.log("res", res);
        if (res?.success) {
          toast.success(" Code resent to your email address ");
          setResendOtp(true);
        }
        // setResendOtp(true);
      });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      otp: "",
    },
    enableReinitialize: true,

    validationSchema: Yup.object({
      otp: Yup.string()
        .required("Please enter the code from your email")
        .matches(/^\d{4}$/, "Must be a 4-digit number"),
    }),

    onSubmit: (value) => {
      value["type"] = 1;
      value["registered_from"] = 2
      value['user_platform_status'] = 1

      let email = localStorage.getItem("email");
      value["email"] = email;

      setLoading(true);
      dispatch(otpVerify(value))
        .unwrap()
        .then((res) => {
          console.log("res", res);
          setLoading(false);
          if (res?.success) {
            navigate(`/redeem-gift`);
            // sessionStorage.setItem("token", res?.token);
            toast.success("Verification successful");
          }
        });
    },
  });

  return (
    <>
      <Box
        sx={{
          height: "100%",
          color: "white",
          background: "black",
          backgroundImage: `url(${assetsObj.Circles})`,
          backgroundSize: "contain",
          backgroundPosition: "left",
          backgroundRepeat: "no-repeat",
          overflow: "auto",
          position: "relative",
          "@media (max-width: 900px)": {
            backgroundImage: "none",
          },
        }}
      >
        <Header />

        <Box
          maxWidth="md"
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            height: "calc(100vh - 133px)",
            maxWidth: "auto",
            "@media (max-width: 900px)": {
              marginTop: "1rem",
            },
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid container>
              <Grid
                item
                xs={12}
                md={6}
                className="leftContent"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                  marginBottom: 7.2,
                }}
              >
                <Box
                  sx={{
                    maxHeight: { lg: "45vh", md: "40vh", xs: "20vh" },
                    position: "relative",
                    marginTop: 4,
                    "@media (max-width: 900px)": {
                      marginBottom: 6,
                    },
                  }}
                  component="img"
                  src={assetsObj.AffirmateNew}
                />
                <Box
                  sx={{
                    maxHeight: { lg: "100vh", md: "100vh", xs: "100vh" },
                    position: "absolute",
                    marginLeft: 5,

                    "@media (min-width: 899px)": {
                      display: "none",
                    },
                    "@media (max-width: 900px)": {
                      marginBottom: 2,
                    },
                  }}
                  component="img"
                  src={assetsObj.Circles}
                />
              </Grid>
              <Grid container item xs={12} md={6}>
                <Grid
                  container
                  item
                  xs={11}
                  md={8}
                  spacing={1}
                  sx={{
                    margin: "auto",
                    "@media (max-width: 900px)": {
                      marginBottom: 5,
                    },
                  }}
                >
                  <Grid item xs={12}>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 400,
                        textAlign: "center",
                        background:
                          "linear-gradient(90deg, rgba(191,90,242,1) 0%, rgba(123,90,255,1) 100%)",
                        backgroundClip: "text",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                      }}
                    >
                      Almost there
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <Typography
                      onChange={handleAgreementChange}
                      sx={{
                        color: "white",
                        fontSize: "14px",
                        fontWeight: 600,
                        marginBottom: 1,
                      }}
                    >
                      Enter the verification code from your email
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sx={{ marginBottom: 1 }}>
                    <WhiteBorderTextField
                      placeholder="4-digit code"
                      type="text"
                      name="otp"
                      onChange={formik.handleChange}
                      value={formik.values.otp}
                      maxLength={4}
                    />
                    {formik.errors.otp && (
                      <FormHelperText error>{formik.errors.otp}</FormHelperText>
                    )}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        borderRadius: "60px",
                        width: "50%",
                        background: "transparent",
                        border: "1px solid white",
                        marginBottom: 1,

                        "&:hover": {
                          background: "white",
                          color: "black",
                          transition: "0.2s ease-in-out",
                        },
                      }}
                      type="submit"
                    >
                      {loading ? (
                        <CircularProgress size={22} color="secondary" />
                      ) : (
                        "Continue"
                      )}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <Button
                      onClick={handleResendCode}
                      variant="text"
                      sx={{
                        color: "white",
                        "&:hover,&:focus,&:active": { background: "none" },
                      }}
                      disabled={ressendOtp}
                      disableTouchRipple
                      disableElevation
                    >
                      {ressendOtp
                        ? `Resend Code in ${resendMin}:${resendSec} seconds`
                        : "Resend Code"}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default Verification;
